/** Curated starter prompts for ConnectWise AI Assistant (no third-party prompt text). */

export type PromptLibraryEntry = {
  id: string;
  title: string;
  body: string;
  tags: string[];
  /** Pick the first id the user is allowed to use (subset of in-app assistants). */
  suggestedAgentIds: string[];
};

export const PROMPT_LIBRARY: PromptLibraryEntry[] = [
  {
    id: 'cw-uni-psa-onboarding',
    title: 'PSA onboarding checklist',
    body:
      'Summarize the essential ConnectWise Manage PSA setup steps for a new admin from ConnectWise University, grouped by phase (company, members, service board, finance).',
    tags: ['university', 'psa', 'onboarding'],
    suggestedAgentIds: ['docs'],
  },
  {
    id: 'cw-uni-automate-flow',
    title: 'Automate workflow design',
    body:
      'Outline how to design a ConnectWise Automate monitor or script workflow for patch compliance, including where to document assumptions and rollback.',
    tags: ['university', 'automate'],
    suggestedAgentIds: ['docs'],
  },
  {
    id: 'gpt-client-email',
    title: 'Client update email',
    body:
      'Draft a concise, professional email to an MSP client explaining a planned maintenance window, impact, and what they need to do. Tone: calm and confident.',
    tags: ['writing', 'msp'],
    suggestedAgentIds: ['gpt'],
  },
  {
    id: 'gpt-incident-summary',
    title: 'Incident summary for ticket',
    body:
      'Turn the following rough notes into a clear incident summary for a PSA ticket: timeline, impact, root cause (if known), actions taken, and next steps.',
    tags: ['tickets', 'operations'],
    suggestedAgentIds: ['gpt'],
  },
  {
    id: 'research-security-baseline',
    title: 'Security baseline research',
    body:
      'What are widely recommended baseline controls for a small MSP managing Microsoft 365 tenants? Summarize with bullet points and note where guidance differs by organization size.',
    tags: ['security', 'research'],
    suggestedAgentIds: ['research'],
  },
  {
    id: 'perplexity-news-scan',
    title: 'Industry news scan',
    body:
      'What are three notable developments in the MSP / IT services industry from the last few weeks? Cite public sources briefly.',
    tags: ['news', 'citations'],
    suggestedAgentIds: ['perplexity_research'],
  },
  {
    id: 'docs-screenconnect-session',
    title: 'ScreenConnect session prep',
    body:
      'From ConnectWise University, list the recommended steps to prepare a ScreenConnect support session and what to verify with the end user beforehand.',
    tags: ['university', 'remote'],
    suggestedAgentIds: ['docs'],
  },
  {
    id: 'gpt-qbr-outline',
    title: 'QBR meeting outline',
    body:
      'Create an outline for a 30-minute quarterly business review with an SMB client: sections, talking points, and 3–5 questions to surface upsell or risk.',
    tags: ['sales', 'meetings'],
    suggestedAgentIds: ['gpt'],
  },
  {
    id: 'research-backup-3-2-1',
    title: 'Backup strategy explainer',
    body:
      'Explain the 3-2-1 backup concept in plain language for a non-technical business owner, including common pitfalls for cloud-only setups.',
    tags: ['backup', 'education'],
    suggestedAgentIds: ['research'],
  },
  {
    id: 'gpt-runbook-template',
    title: 'Runbook skeleton',
    body:
      'Produce a reusable runbook template for an MSP NOC: purpose, scope, prerequisites, steps, verification, rollback, and communications checklist.',
    tags: ['runbooks', 'noc'],
    suggestedAgentIds: ['gpt'],
  },
];
